<template>
<div class="chapter">
<div class="inner_page">
<h3 class="sigil_not_in_toc"><span class="small">PART I</span></h3>
<h1 id="sigil_toc_id_1" title="Part I: 1983-87">1983-87</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_part01.vue?1fb03fa0